let state = {
  
    ofertagradeempresa:[],

}

export default state